import { Component } from '@angular/core';
import { ThemeService } from './shared/services/theme.service';
import { AppConfigService } from './shared/services/config/app-config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {

    constructor(private themeService: ThemeService,
        private appConfigService: AppConfigService) {
        // Subscribe to config updates and apply theme
        this.appConfigService.onAppConfigUpdated$.subscribe(() => {
            const config = AppConfigService.getConfig();
            if (config?.theme) {
                this.themeService.applyTheme(config.theme);
            }
        });
    }
}
